module.exports = __webpack_public_path__ + "media/images/pack-bg-01-80e419e543916086613659e42c93f70a.svg";